import React, { useEffect }                     from 'react'
import axios                                    from 'axios'
import {
   bubbleSortArrayOfObjects,
   node_server
}                                               from '../Helpers'
import PropTypes                                from 'prop-types'
import { store }                                from '../Redux/Store'

const GetBioListPartial = ({getBioListPartial}) => {

   const { goodLogin }                          =  store.getState()

   useEffect( () => {
      axios.get(node_server + 'bio/GetAllBiosPartial')
         .then( res => res.data )
         .then( data => {
            bubbleSortArrayOfObjects(data, 'lastName')

               /* Sends back the appropriate bios based on whether the user is logged in or not */
               if( goodLogin ){
                  /* Sends the bio list back to <BioList /> */
                  getBioListPartial(data)
               }
               else {
                  const filteredData = data.filter( bio => {
                     if( bio.publicBio ){ return bio }
                     else{ return null}
                  } )
                  /* Sends the filtered bio list back to <BioList /> */
                  getBioListPartial(filteredData)
               }
         } )
   }, [getBioListPartial, goodLogin] )

   return (
      <div>
         
      </div>
   )
}

GetBioListPartial.propTypes = {
    getBioListPartial: PropTypes.func
}

export default GetBioListPartial
